import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

import './modal.module.scss';

const customStyles = {
    overlay: {
        backgroundColor: ''
    },
    content: {
        position: '', padding: '', display: '', background: '', border: ''
    }
};

const Modal = (props) => (
    <ReactModal
        style={ customStyles }
        isOpen={ props.isOpen }
        onRequestClose={ props.closeModal }
        shouldCloseOnOverlayClick={ props.shouldCloseOnOverlayClick }
        { ...props.reactModalProps }
    >
        { props.children }
    </ReactModal>
);

Modal.setAppElement = ReactModal.setAppElement;

Modal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    reactModalProps: PropTypes.shape({}),
    shouldCloseOnOverlayClick: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
};

Modal.defaultProps = {
    reactModalProps: {},
    shouldCloseOnOverlayClick: true
};

export default Modal;
